import { useBlockProps, RichText, InnerBlocks } from '@wordpress/block-editor';
export default function save( { attributes, clientId } ) {
	const { themeDark } = attributes;
	const activeTabIndex = 0;
	const tabBar = ( tabs ) => {
		return tabs
			.sort( ( a, b ) => a.index - b.index )
			.map( ( tab, index ) => {
				return (
					<div
						key={ index }
						className="mdc-tab mdc-tab--active"
						role="tab"
						aria-selected="true"
						tabIndex={ tab.index }
					>
						<span className="mdc-tab__content">
							<RichText.Content
								tagName="span"
								className="mdc-tab__text-label"
								value={ tab.title }
							/>
						</span>
						<span
							className={
								tab.index === activeTabIndex
									? 'mdc-tab-indicator mdc-tab-indicator--active'
									: 'mdc-tab-indicator'
							}
						>
							<span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
						</span>
					</div>
				);
			} );
	};

	const blockProps = useBlockProps.save();
	return (
		<div { ...blockProps } className={themeDark ? "tab-wrap theme-dark" : "tab-wrap"}>
			<div className={ `tab-wrapper ask__wrapper` } id={ clientId }>
				<div className="mdc-tab-bar" role="tablist">
					<div className="mdc-tab-scroller">
						<div className="mdc-tab-scroller__scroll-area">
							<div className="mdc-tab-scroller__scroll-content">
								{ tabBar( attributes.tabs ) }
							</div>
						</div>
					</div>
				</div>
				<InnerBlocks.Content />
			</div>
		</div>
	);
}
